const TSHIRT_CATEGORY = 't-shirt';
const HOODIES_CATEGORY = 'hoodies';
const WALL_ART_PREMIUM_CATEGORY = 'premium-wall-art';
const WALL_ART_STANDARD_CATEGORY = 'standard-wall-art';

export const availableProductStyleSwitchCategories: string[] = [
  TSHIRT_CATEGORY,
  HOODIES_CATEGORY,
  WALL_ART_PREMIUM_CATEGORY,
  WALL_ART_STANDARD_CATEGORY,
];

export const categoryProductStyleList = Object.freeze({
  [TSHIRT_CATEGORY]: [
    'cactus-bizzo',
    'cluey-kookaburra',
    'billowing-parachute',
    'sooky-sanga',
    'unreal-chinwag',
    'calm-wrapper',
    'weathered-wrapper',
    'blockish-wrapper',
    'ripper-rissole',
    'flaming-ute',
    'outback-brolly',
    'chrissy-chungus',
    'grouse-chips',
    'shouty-pav',
    'tall-larrikin',
    'wonky-mozzie',
    'peckish-flannel',
    'cheeky-cockatoo',
  ],
  [HOODIES_CATEGORY]: [
    'fair-cuppa', // hoodie
    'jumping-boot', // sweatshirt
    'bonza-lamington', // zipper hoodie,
    'billowing-falsehood', // premium oversized hoodie,
    'billowing-swelter', // premium oversized sweatshirt
    'whinging-magpie', // lightweight hoodie
    'aggro-emu', // lightweight sweatshirt
  ],
  [WALL_ART_STANDARD_CATEGORY]: [
    'shouty-flannel', // tapestry
    'strewn-joey', // art print
    'beaut-flannel', // poster
    'fair-garage', // photographic print
    'shifting-brolly', // art board print
  ],
  [WALL_ART_PREMIUM_CATEGORY]: [
    'googy-veggies', // framed art print
    'outback-mate', // canvas print
  ],
});
